import { ASSETS } from "assets";
import { Formik } from "formik";
import AuthenticationForm from "lib/components/authentication/authentication-form";
import ErrorBox from "lib/components/common/error-box";
import FlexBox from "lib/components/common/flex-box";
import Hyperlink from "lib/components/common/hyperlink";
import SimplePasswordField from "lib/components/common/simple-password";
import AuthenticationLayout from "lib/components/layouts/authentication";
import {
  DEFAULT_PASSWORD_RESET_VALUES,
  DEFAULT_RESET_PASSWORD_VALUES,
} from "lib/constants/default-values";
import { PAGE_ROUTES } from "lib/constants/page-routes";
import {
  FORGOT_PASSWORD_VALIDATION_SCHEME,
  PASSWORD_VALIDATION_SCHEMA,
} from "lib/constants/validation-constants";
import useAuthentication from "lib/hooks/useAuthentication";
import { useEffect, useState } from "react";
import { Button, Image, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

// This page is for resetting the password
// User will be redirected to this page when they click on the reset password link in the email sent from Stytch

const ChangePasswordPage = () => {
  const { changePassword, loading, error } = useAuthentication();
  const navigateTo = useNavigate();

  const [token, setToken] = useState<string | null>(null);

  useEffect(() => {
    const stytchToken = new URLSearchParams(window.location.search).get(
      "token"
    );
    if (stytchToken) {
      setToken(stytchToken);
    } else {
      toast.error("Invalid token");
      // window.setTimeout(
      //   () => navigateTo(PAGE_ROUTES.AUTHENTICATION.Login),
      //   3000
      // );
    }
  }, []);

  const handleSuccess = () => {
    toast.success("Password reset successful");
    window.setTimeout(() => navigateTo(PAGE_ROUTES.AUTHENTICATION.Login), 3000);
  };

  return (
    <AuthenticationLayout>
      <FlexBox className="h-100" justifyContent="around">
        <Image
          src={ASSETS.IMAGES.LOGIN_IMAGE}
          alt="Sign In"
          className="login-image"
        />
        <AuthenticationForm isLoading={loading}>
          <FlexBox justifyContent="start" className="mb-4 mx-2">
            <h2>Change Password</h2>
          </FlexBox>
          <Formik
            initialValues={DEFAULT_PASSWORD_RESET_VALUES}
            onSubmit={(values: PasswordResetRequest) => {
              if (values.password !== values.confirmPassword) {
                toast.error("Passwords do not match");
                return;
              }
              if (token) {
                values.token = token;
              }
              changePassword(values, handleSuccess);
            }}
          >
            {({ values, handleChange, handleSubmit }) => (
              <Form onSubmit={handleSubmit}>
                <SimplePasswordField
                  label="New Password"
                  name="password"
                  value={values.password}
                  className="form-control"
                  onChange={handleChange}
                  validationSchema={PASSWORD_VALIDATION_SCHEMA}
                  isShowVisibilityIcon
                  required
                />
                <SimplePasswordField
                  label="Confirm Password"
                  name="confirmPassword"
                  value={values.confirmPassword}
                  className="form-control"
                  onChange={handleChange}
                  validationSchema={PASSWORD_VALIDATION_SCHEMA}
                  required
                />
                {error && <ErrorBox message={error} />}
                <Form.Group className="form-group login-btn text-center">
                  <Button
                    type="submit"
                    disabled={loading}
                    className="btn btn-primary px-4"
                  >
                    Submit
                  </Button>
                </Form.Group>
              </Form>
            )}
          </Formik>
          <p className="text-center px-4 mt-2">
            Back to{" "}
            <Hyperlink to={PAGE_ROUTES.AUTHENTICATION.Login}>Sign In</Hyperlink>
          </p>
        </AuthenticationForm>
      </FlexBox>
    </AuthenticationLayout>
  );
};

export default ChangePasswordPage;
